export default {
  'common.operation': '操作',
  'product.management.title': '商品管理',
  'product.management.add': '新增商品',
  'product.management.edit': '编辑商品',
  'product.management.delete': '删除商品',
  'product.management.enable': '启用',
  'product.management.disable': '禁用',
  'product.management.search': '搜索',
  'product.management.reset': '重置',
  'product.management.name': '商品名称',
  'product.management.type': '商品类型',
  'product.management.currency': '币种',
  'product.management.status': '状态',
  'product.management.value': '商品价值',
  'product.management.amount': '商品数量',
  'product.management.price': '商品积分',
  'product.management.quantity': '商品个数',
  'product.management.limit': '限购次数',
  'product.management.dailyLimit': '每日限购',
  'product.management.vipLimit': '限购次数',
  'product.management.vipLimitDisplay': 'VIP {{value}}',
  'product.management.vipPurchaseLimit': 'VIP限购',
  'product.management.vipPurchaseLimitCount': '限购次数',
  'product.management.vipPurchaseLimitEnabled': '是否开启',
  'product.management.vipLevel': 'VIP',
  'product.management.vipLimitZeroError': '启用的VIP等级限购次数不能为0',
  'product.management.sort': '排序',
  'product.management.flow': '商品流水',
  'product.management.cash': '现金',
  'product.management.props': '道具',
  'product.management.propsCategory': '道具分类',
  'product.management.propsCategory.luckySpin': '大转盘券',
  'product.management.propsCategory.fuel': '推进货币',
  'product.management.propsCategory.treasureBoxKey': '宝箱钥匙',
  'product.management.keyType': '钥匙类型',
  'product.management.keyType.WOOD': '木钥匙',
  'product.management.keyType.IRON': '铁钥匙',
  'product.management.keyType.BRONZE': '青铜钥匙',
  'product.management.keyType.SILVER': '白银钥匙',
  'product.management.keyType.GOLD': '黄金钥匙',
  'product.management.keyType.DIAMOND': '钻石钥匙',
  'product.management.physical': '实物',
  'product.management.unknown': '未知类型',
  'product.management.unknownStatus': '未知状态',
  'product.management.operator': '操作人',
  'product.management.operateTime': '操作时间',
  'product.management.confirmDelete': '是否删除',
  'product.management.confirmDisable': '是否禁用',
  'product.management.confirmEnable': '是否启用',
  'product.management.success': '操作成功',
  'product.management.fail': '操作失败',
  'product.language.title': '语言管理',
  'product.language.add': '新增语言',
  'product.language.edit': '编辑语言',
  'product.language.name': '商品名称',
  'product.language.language': '语言',
  'product.language.image': '商品图片',
  'product.language.operator': '操作人',
  'product.language.operateTime': '操作时间',
  'product.language.confirmDelete': '是否删除',
  'product.language.success': '操作成功',
  'product.language.fail': '操作失败',
  'product.language.delete': '删除',
  'product.stock.title': '商品库存',
  'product.stock.edit': '编辑库存',
  'product.stock.viewHistory': '查看明细',
  'product.stock.name': '商品名称',
  'product.stock.available': '可用库存',
  'product.stock.freeze': '冻结库存',
  'product.stock.total': '总库存',
  'product.stock.changeType': '变动类型',
  'product.stock.changeAmount': '变动数量',
  'product.stock.remark': '备注',
  'product.stock.increase': '增加',
  'product.stock.decrease': '减少',
  'product.stock.history': '库存变动明细',
  'product.stock.operator': '操作人',
  'product.stock.operateTime': '操作时间',
  'product.stock.success': '库存更新成功',
  'product.stock.fail': '库存更新失败',
  'product.stock.recordNotFound': '记录数据不存在',
  'product.trade.title': '商品交易记录',
  'product.trade.orderId': '兑换ID',
  'product.trade.memberAccount': '会员账号',
  'product.trade.type': '商品类型',
  'product.trade.name': '商品名称',
  'product.trade.currency': '币种',
  'product.trade.value': '商品价值',
  'product.trade.price': '商品积分',
  'product.trade.quantity': '兑换数量',
  'product.trade.time': '兑换时间',
  'product.trade.vipLevel': 'VIP等级',
  'product.trade.fail': '数据加载失败',
  'product.trade.export': '导出',
  'product.trade.exportWarning': '请选择时间范围',
  'product.trade.exportLoading': '正在导出数据...',
  'product.trade.exportSuccess': '导出成功',
  'product.trade.exportFail': '导出失败'
};
